// AI-CONTEXT: See docs/features/participation-ladder.md
import defaultParticipationParameters from './defaultParticipationParameters'
import deriveParticipationStep from './deriveParticipationStep'
import getSituationLabel from './getSituationLabel'
import computeIncomeTax from './computeIncomeTax'
import { PAID_WORK_ACTIVITY } from './participationOptions'

const lookupGrossIncome = (parameters, educationLevel, hoursBand) => {
    const table = parameters.incomeByEducationAndHoursBand || {}
    const byBand = table[educationLevel]
    if (!byBand) return 0
    const income = byBand[hoursBand]
    return Number.isFinite(income) ? income : 0
}

// Computes the four monetary components for one moment (T0 or T1), following
// the "Output Participatieladder" sheet:
//   - incomePerson  = gross income (education x hours band) x employability
//   - incomeTax     = progressive tax on the FULL gross income (not employability-adjusted)
//   - benefitCost   = yearly benefit cost (negative), x benefitShare for bijstand
//   - volunteerValue= volunteer hours x rate x weeks (only for Vrijwilligerswerk)
const calculateParticipationState = (profile = {}, parameters = defaultParticipationParameters) => {
    const p = { ...defaultParticipationParameters, ...parameters }

    const isPaidWork = profile.mainActivity === PAID_WORK_ACTIVITY
    const employability = Number.isFinite(Number(profile.employabilityFactor))
        ? Number(profile.employabilityFactor)
        : 1

    const grossIncome = isPaidWork ? lookupGrossIncome(p, profile.educationLevel, profile.hoursBand) : 0
    const incomePerson = grossIncome * employability
    const incomeTax = isPaidWork ? computeIncomeTax(grossIncome, p.taxBrackets) : 0

    // Meetstandaard-parameters 2026.2: wie deels werkt houdt soms aanvullende
    // bijstand. benefitShare is het deel van de volledige norm; zonder antwoord
    // telt de volledige uitkering, zoals vóór 2026.2.
    const shareApplies = p.benefitRules.shareAppliesTo.includes(profile.benefitType)
    const benefitShare = shareApplies && Number.isFinite(profile.benefitShare) ? profile.benefitShare : 1
    const benefitCost = (p.benefitAmountPerYear[profile.benefitType] || 0) * benefitShare

    // Public cost: the yearly cost of administering a bijstand benefit
    // (uitvoeringskosten). Saved once the participant leaves bijstand; not
    // scaled by benefitShare (benefitRules.uitvoeringskostenScaleWithShare).
    const publicCost = profile.benefitType === 'Bijstandsuitkering'
        ? (p.bijstandUitvoeringskostenPerYear || 0)
        : 0

    const volunteerHours = profile.mainActivity === 'Vrijwilligerswerk'
        ? Math.max(0, Number(profile.volunteerHoursPerWeek) || 0)
        : 0
    const volunteerValue = volunteerHours * p.volunteerValuePerHour * p.weeksPerYear

    return {
        situationLabel: getSituationLabel(profile),
        ladderStep: deriveParticipationStep(profile),
        incomePerson, // = productivityValue (gross income x employability)
        incomeTax,
        netIncome: incomePerson - incomeTax,
        benefitCost,
        publicCost,
        volunteerValue,
    }
}

export default calculateParticipationState
